import React from 'react';

export interface UiSliderProps {
  value: number;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
  onChange: (value: number) => void;
  onPointerDown?: React.PointerEventHandler<HTMLInputElement>;
  onPointerUp?: React.PointerEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
}

export default function UiSlider({ value, min = 0, max = 1, step = 0.01, disabled, className = '', onChange, onPointerDown, onPointerUp, onKeyDown, onBlur, ...rest }: UiSliderProps) {
  return (
    <input
      type="range"
      value={value}
      min={min}
      max={max}
      step={step}
      onChange={(e) => onChange(Number(e.target.value))}
      onPointerDown={onPointerDown}
      onPointerUp={onPointerUp}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      disabled={disabled}
      className={[
        'w-full appearance-none h-1 rounded bg-neutral-700/70 outline-none',
        'accent-neutral-600/80',
        'disabled:opacity-50',
        className,
      ].join(' ')}
      {...rest}
    />
  );
}
